<div class="container">
    <div class="row">
        <div class="col-12"> 
            <p class="heading3_1">Copy and share with your friends</p>
        </div>     
    </div>
</div>